<template lang='pug'>
  include ./../../mixins
  div
    +b.close-modal.fs_md.color_main-3.mdi.mdi-close.cursor-pointer.BUTTON(@click='toggleHandler')
    +b.modal-img.bgi-basic-contain.margin_center.margin_bottom_1xl
    +b.text--center.font-weight_medium.color_dark.line-height_lg.fs_3md.P {{_('Your password was succesfully changed')}}
    +e.button.button--color_blue.--width_full.fs_md.margin_center.margin_top_2xl.display_block.A(:href='url') {{_('Login')}}
      
</template>

<script>
export default {
  props: {
    url: {
      type: String
    }
  },

  methods: {
    toggleHandler() {
      this.$modal.hide("PasswordModal")
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/js/components/Modals/SuccessModal.vue